import { Config, ConfigParams } from '../../config/types'
import { featureConfig } from './enum-config'

const defaultConfig: Config = {
  [featureConfig.RECOMENDADOS_BUMI]: false,
  [featureConfig.DIRECCION_AUTOCOMPLETE]: true,
  [featureConfig.SELECTA]: false,
  [featureConfig.AVISO_NIVELES_LABORALES_RESTRINGIDOS]: {},
  [featureConfig.AVISO_HUNTER]: false,
  [featureConfig.AVISO_HUNTER_EMPRESAS]: [],
  [featureConfig.AVISO_CONECTA_LIMITAR_AREA]: false,
  [featureConfig.ESTADISTICAS_EMPRESAS]: false,
  [featureConfig.ESTADISTICAS_COMPARATIVAS_EMPRESAS]: false,
  [featureConfig.ESTADISTICAS_VISTAS_EMPRESAS]: false,
  [featureConfig.JOBI]: false,
  [featureConfig.JOBI_EMPRESAS]: [],
  [featureConfig.HOME_HIDDEN_PRICES_PRODUCTS]: false,
  [featureConfig.ENCABEZADO_AVISOS]: false,
  [featureConfig.BENEFICIOS_AVISOS]: false,
  [featureConfig.ENCABEZADO_PERFIL]: false,
  [featureConfig.BENEFICIOS_PERFIL]: false,
  [featureConfig.DASHBOARD_DEFAULT]: false,
  [featureConfig.ECOMMERCE_DISABLED_ITEMS]: [],
  [featureConfig.BUSQUEDA_EN_BASE]: false,
  [featureConfig.NEW_SEARCH_BAR]: false,
  [featureConfig.BANNER_GRATIS]: false,
  [featureConfig.AVISO_TAG_NEW]: [],
  [featureConfig.AVISO_CUPON]: false,
  [featureConfig.AVISO_PALABRAS_RESTRINGIDAS]: ['computrabajo'],
  [featureConfig.PUBLICACION_SIN_REVISION_MANUAL]: false,
  [featureConfig.MODAL_UPGRADE_EXPRESS]: false,
  [featureConfig.AVISOS_CON_RECOMENDADOS]: {},
  [featureConfig.AVISOS_CON_SUGERIDOS]: {},
  [featureConfig.EMPRESAS_SOBRECARGADAS]: [],
  [featureConfig.PANEL_EMPRESAS]: false,
  [featureConfig.PANEL_EMPRESAS_CONSULTORAS]: false,
  [featureConfig.PRODUCTOS_CARACTERISTICAS]: false,
  [featureConfig.PROVINCIA_SAP_REGISTRO]: false,
  [featureConfig.MENSAJES_EMPRESAS]: true,
  [featureConfig.MENSAJES_EMPRESAS_LANDING]: true,
  [featureConfig.MENSAJES_EMPRESAS_LANDING_FULLPAGE]: false,
  BMPE: {
    [featureConfig.MODAL_UPGRADE_EXPRESS]: true,
  },
  BMVE: {
    [featureConfig.BUSQUEDA_EN_BASE]: true,
    [featureConfig.NEW_SEARCH_BAR]: true,
  },
  BMMX: {
    [featureConfig.BUSQUEDA_EN_BASE]: true,
    [featureConfig.NEW_SEARCH_BAR]: true,
  },
  [featureConfig.ENVIRONMENTS]: [
    ['prod', 'www.*'],
    ['prepro', 'prepro.*', 'prepro-internal.*', 'prepro-tracking.*'],
    ['qa', '*.qa.*'],
    ['arbusta', 'arbusta*'],
    ['local', 'localhost', 'local.*'],
  ],
}

export default defaultConfig as ConfigParams
